"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextFileScope = exports.SYSTEM_PROMPT_INJECTED_FILE_TYPES = exports.isDocumentFileType = exports.DOCUMENT_FILE_TYPES = exports.ContextFileType = void 0;
/**
 * Types of context files.
 * Stored as string in database for flexibility.
 */
exports.ContextFileType = {
    /**
     * Legacy value with no writer: the onboarding status-quo report is written as
     * `BRAND_STATUS_QUO`. Kept so any pre-existing rows stay readable and typed —
     * do not write new rows with this type, and do not use it as an example type.
     */
    MARKETING_STATUS_QUO: 'MARKETING_STATUS_QUO',
    TARGET_GROUPS: 'TARGET_GROUPS',
    BRAND_CREATIVE_CONTEXT: 'BRAND_CREATIVE_CONTEXT',
    PRODUCT_CREATIVE_CONTEXT: 'PRODUCT_CREATIVE_CONTEXT',
    BRAND_STATUS_QUO: 'BRAND_STATUS_QUO',
    // Brand-intelligence reports built from the brand's own signals during onboarding
    BRAND_VISUAL_STYLE: 'BRAND_VISUAL_STYLE',
    BRAND_STATIC_AD_RULES: 'BRAND_STATIC_AD_RULES',
    BRAND_CUSTOMER_PAIN_POINTS: 'BRAND_CUSTOMER_PAIN_POINTS',
    BRAND_IDEAL_CREATIVE_DIRECTION: 'BRAND_IDEAL_CREATIVE_DIRECTION',
    DYNAMIC: 'DYNAMIC',
    LOGO_GUIDELINES: 'LOGO_GUIDELINES',
    COLOR_GUIDELINES: 'COLOR_GUIDELINES',
    APP_ICON_GUIDELINES: 'APP_ICON_GUIDELINES',
    /**
     * Legacy value for pre-document campaign briefs; data-migrated to DOCUMENT.
     * Kept only until the migration has run everywhere — do not write new rows
     * with this type.
     */
    CAMPAIGN_BRIEF: 'CAMPAIGN_BRIEF',
    /**
     * A working document — durable, titled paperwork authored by a manager stream
     * (brief, plan, analysis). Stored as a context file for persistence/versioning
     * and entity-link sync, addressed as `document://<uuid>`, but excluded from the
     * context-file glossary, UI pages, and RAG search so it never surfaces as
     * generic brand knowledge; access is by reference.
     */
    DOCUMENT: 'DOCUMENT',
};
/**
 * File types that are documents (manager work-paperwork, `document://`-addressed).
 * Includes the legacy CAMPAIGN_BRIEF value until its data migration has run
 * everywhere — retiring it then is a single edit here.
 */
exports.DOCUMENT_FILE_TYPES = [exports.ContextFileType.DOCUMENT, exports.ContextFileType.CAMPAIGN_BRIEF];
/** Whether a context file is a document (vs. brand knowledge). */
const isDocumentFileType = (fileType) => fileType != null && exports.DOCUMENT_FILE_TYPES.includes(fileType);
exports.isDocumentFileType = isDocumentFileType;
/**
 * File types whose content is injected verbatim into the orchestrator's system prompt.
 * Created by `TypedContextFileWriter` during onboarding and label changes, and marked
 * `isRequired: true` so they cannot be deleted by users.
 */
exports.SYSTEM_PROMPT_INJECTED_FILE_TYPES = [
    exports.ContextFileType.APP_ICON_GUIDELINES,
    // Brand status quo + objectives from the onboarding questionnaire — inlined verbatim so it steers every turn.
    exports.ContextFileType.BRAND_STATUS_QUO,
    // Brand-intelligence reports (ENG-3713) — inlined so they steer every generation.
    exports.ContextFileType.BRAND_VISUAL_STYLE,
    exports.ContextFileType.BRAND_STATIC_AD_RULES,
    exports.ContextFileType.BRAND_CUSTOMER_PAIN_POINTS,
    exports.ContextFileType.BRAND_IDEAL_CREATIVE_DIRECTION,
];
/**
 * Context file scope levels for filtering.
 */
exports.ContextFileScope = {
    ORGANIZATION: 'ORGANIZATION',
    BRAND: 'BRAND',
    PRODUCT: 'PRODUCT',
};
